export const PLATFORM_URL = "https://app.onechatting.com";
export const LOGIN_URL = `${PLATFORM_URL}/login`;
export const REGISTER_URL = `${PLATFORM_URL}/register`;
export const API_DOCS_URL = "https://docs.onechatting.com";
